export default {
    bigIcon:     'bigIcon',
    grayRounded: 'grayRounded',
    redRounded:  'redRounded',
};